import { Badge } from "@/components/ui/badge";

export function StockBadge({ status }) {
  const map = {
    healthy: { bg: "#10B981", label: "In Stock" },
    low: { bg: "#F59E0B", label: "Low Stock" },
    out: { bg: "#EF4444", label: "Out of Stock" },
  };
  const c = map[status] || map.healthy;
  return (
    <span
      data-testid={`stock-badge-${status}`}
      className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-semibold text-white"
      style={{ background: c.bg }}
    >
      {c.label}
    </span>
  );
}

export function ExpiryBadge({ state, days }) {
  const map = {
    expired: { bg: "#EF4444", label: `Expired ${days != null ? Math.abs(days) + "d ago" : ""}` },
    expiring: { bg: "#F59E0B", label: `${days}d left` },
    warning: { bg: "#0a8f8f", label: `${days}d left` },
    healthy: { bg: "#10B981", label: days != null && days < 9999 ? `${days}d left` : "OK" },
  };
  const c = map[state] || map.healthy;
  return (
    <span
      data-testid={`expiry-badge-${state}`}
      className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-semibold text-white"
      style={{ background: c.bg }}
    >
      {c.label}
    </span>
  );
}

export function RequisitionBadge({ status }) {
  const map = {
    pending: { bg: "#F59E0B", label: "Pending Approval" },
    approved: { bg: "#0a8f8f", label: "Approved" },
    rejected: { bg: "#EF4444", label: "Rejected" },
    issued: { bg: "#6366F1", label: "Issued" },
    received: { bg: "#10B981", label: "Received" },
  };
  const c = map[status] || map.pending;
  return (
    <span
      data-testid={`requisition-badge-${status}`}
      className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-semibold text-white"
      style={{ background: c.bg }}
    >
      {c.label}
    </span>
  );
}

export function FefoBadge() {
  return (
    <span
      data-testid="fefo-badge"
      className="inline-flex items-center px-2 py-0.5 rounded-full text-[10px] font-bold text-white"
      style={{ background: "#10B981" }}
    >
      USE FIRST (FEFO)
    </span>
  );
}
